import { makeStyles } from "@material-ui/core";
import { DialogSaurusProps } from "./dialog-saurus-props";

export interface DialogSaurusStylesProps extends DialogSaurusProps {
    tamanhoContainer: number | string;
}

export const useStyles = makeStyles((theme) => ({
    closeButton: {
        color: theme.palette.grey[500],
        padding: 4,
        margin: 0,
        '& svg': {
            padding: 0,
            margin: 0
        }
    },
    containerTitle: ({ titulo }: DialogSaurusStylesProps) => ({
        display: 'flex',
        justifyContent: titulo ? 'space-between' : 'flex-end',
    }),
    title: ({ colorTitulo }: DialogSaurusStylesProps) => ({
        color: colorTitulo ? colorTitulo : '',
        fontWeight: 700
    }),
    subTitle: ({ colorSubTitulo }: DialogSaurusStylesProps) => ({
        color: colorSubTitulo ? colorSubTitulo : '',
        fontWeight: 500
    }),
    titleCentralizado: ({ centralizarTitulo }: DialogSaurusStylesProps) => ({
        display: 'flex',
        justifyContent: centralizarTitulo ? 'center' : 'flex-start',
        alignItems: centralizarTitulo ? 'center' : 'flex-start',
    }),
    dialogContent: ({
        removerPaddingContent = false,
        fullHeightContent = false
    }: DialogSaurusStylesProps) => ({
        padding: removerPaddingContent ? 0 : '',
        height: fullHeightContent ? '100%' : ''
    }),
    containerBtnClose: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    container: ({ tamanhoContainer }: DialogSaurusStylesProps) => ({
        height: tamanhoContainer ?? '100%',
        maxHeight: tamanhoContainer ?? '100%',
        minHeight: 200,
    })
}));
